import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <Navigation />
      <div className="max-w-2xl mx-auto px-6 py-24">
        <Card>
          <CardHeader className="text-center">
            <XCircle className="w-16 h-16 mx-auto mb-4 text-red-500" />
            <CardTitle className="text-3xl font-heading" data-testid="cancel-title">Payment Cancelled</CardTitle>
            <CardDescription>Your payment was cancelled. No charges were made.</CardDescription>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-sm text-muted-foreground">
              You can try again whenever you're ready. The contract is still waiting for payment.
            </p>
            <Button
              onClick={() => navigate('/dashboard')}
              className="bg-primary text-primary-foreground"
              data-testid="dashboard-button"
            >
              Return to Dashboard
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;
